// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"725":"cc2e1a0b","755":"3f6ebf54"}[chunkId] + ".js";
};